export const defaultStyle = {
    wrapper: "relative bg-darkRed flex flex-col justify-center items-center py-[100px] lg:py-[156px] xl:py-[180px]",
    contentWrapper: "section-wrapper space-y-[32px]",
    titleSection: "space-y-[10px]",
    heading: "text-white text-center headline3 md:headline5 title-shadow",
    description: "body-m text-white text-center",
    content: "flex flex-col items-center lg:flex-row lg:space-x-[20px] xlg:space-x-[141px]",
}
